import styled from 'styled-components';
import { rgba } from 'polished';
import Icon from '../icon';

export const StyledIcon = styled(Icon)`
	margin: 1rem 1.375rem;

	path {
		transition: fill 100ms;
		fill: ${({ theme, isActive }) => isActive ? theme['white'] : rgba(theme['white'], 0.3)};
	}
`;

export const Container = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	transition: color 100ms, background-color 100ms;
	color: ${({ theme, isActive }) => isActive ? theme['white'] : rgba(theme['white'], 0.3)};
	cursor: pointer;

	span {
		font-size: 0.9rem;
		font-weight: 700;
	}

	&::after {
		content: '';
		display: ${({ hasUnread }) => hasUnread ? 'block' : 'none'};
		position: absolute;
		top: 0.6875rem;
		left: 2.3125rem;
		width: 0.625rem;
		height: 0.625rem;
		border-radius: 50%;
		background-color: ${({ theme }) => theme['blue-base']};
	}

	&:hover {
		background-color: ${({ theme }) => theme['midnight-lighten-10']};
		color: ${({ theme }) => theme['white']};

		${StyledIcon} {
			path {
				fill: ${({ theme }) => theme['white']};
			}
		}
	}
`;
